import { TicketBlueprintKind as GqlKind } from '../../../generated/api.graphql';

/** Whether a ticket blueprint is admission or an add-on; wrapped because `@vp/admin` cannot import generated types. */
export const TicketBlueprintKind = Object.freeze({
  TICKET: GqlKind.Ticket,
  ADDON: GqlKind.Addon,
});
export type TicketBlueprintKind = (typeof TicketBlueprintKind)[keyof typeof TicketBlueprintKind];
